import NavbarSidebarWrapper from "../../../components/navbarSidebarWrapper";
import actions from "../../../redux/actions";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import * as MdIcons from 'react-icons/md';
import { useAuth } from "../../../context/AuthContext";

const ShowMatkaBet = () => {

    const myBetList = useSelector((state) => state.smBetSlice.smMyBetList?.Result);

    let { Mid } = useParams();
    let { user } = useAuth();

    let navigate = useNavigate();
    useEffect(() => {
        actions.getSMMyBets(Mid);
    }, [Mid, user.uid])


    return (
        <NavbarSidebarWrapper>
            <div className="content-wrapper me-0" > {/* main content wrapper */} {/* Apply the custom border color */}
                <div className="content-header d-flex justify-content-between">
                    <span className="">Show Bet</span>
                </div>
                <button className="btn violet_button" onClick={() => navigate(`/matka-profit-loss`)}><MdIcons.MdArrowBackIos />Back</button>
                <div className="table-responsive mt-2">
                    <div className="table-wrapper">
                        <table className="table table-striped">
                            <thead>
                                <th>S.No.</th>
                                <th>Market ID.</th>
                                <th>Market Name</th>
                                <th>IP Address</th>
                                <th>Bet No</th>
                                <th>Amount</th>
                                <th>P/L</th>
                                <th>Bet Status</th>
                                {/* <th>Action</th> */}
                            </thead>
                            <tbody>
                                {myBetList && Array.isArray(myBetList) && myBetList?.length > 0 ? myBetList?.map((item, index) => (
                                    <tr key={index}>
                                        <td className="dark-table-cell">{index + 1}</td>
                                        <td className='dark-table-cell'>{item?.MarketId} </td>
                                        <td className="dark-table-cell">{item?.MatchName} </td>
                                        <td className='dark-table-cell'>{item?.IP_Address} </td>
                                        <td className="dark-table-cell">{item?.betNo} </td>
                                        <td className="dark-table-cell">{item?.Amount} </td>
                                        <td className={`${item?.PL < 0 ? 'dark-table-cell red-text' : 'dark-table-cell green-text'}`}>{item?.PL} </td>
                                        <td className="dark-table-cell">{item?.BetStatus} </td>
                                        {/* <td className="dark-table-cell">{item?.PL} </td> */}
                                        {/* <td className="dark-table-cell">{item?.commission} </td>
                                        <td className="dark-table-cell active-link" onClick={() => navigate(`/betting_history/${item?.marketId}/${item?.userId}`, { state: { SelectionID: item?.Selectionid, marketType: item?.marketType } })}>show bet</td> */} 

                                    </tr>
                                ))
                                    :
                                    <tr>
                                        <td className="text-center" colSpan='6'>No Result</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </NavbarSidebarWrapper>
    )
}

export default ShowMatkaBet;